import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import { LoopyMark } from '../loopy';
import './Footer.css';

const Footer: React.FC = () => {
  const { t } = useTranslation('home');
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-main">
          {/* Left: Brand + description + CTA */}
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <LoopyMark size={28} />
              <span>Loopy AI</span>
            </Link>
            <p className="footer-description">{t('footer.description')}</p>
            <Link to="/courses" className="footer-cta">
              {t('footer.ctaText')}
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </Link>
          </div>

          {/* Right: Links (single column) */}
          <div className="footer-links">
            <nav className="footer-nav-links">
              <Link to="/courses">{t('footer.courses')}</Link>
              <Link to="/pricing">{t('footer.pricing')}</Link>
              <Link to="/placement-test">{t('footer.levelTest')}</Link>
              <Link to="/creator/wizard">{t('footer.creators')}</Link>
              <Link to="/about">{t('footer.about')}</Link>
            </nav>
            <div className="footer-legal-links">
              <Link to="/terms">{t('footer.terms')}</Link>
              <span className="footer-link-sep">·</span>
              <Link to="/privacy">{t('footer.privacy')}</Link>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">{t('footer.copyright', { year: currentYear })}</p>
          <LanguageSwitcher />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
